import {
    Component,
    OnInit,
    Input,
    AfterViewInit,
    OnDestroy,
    ChangeDetectionStrategy,
    ChangeDetectorRef
} from '@angular/core';
import { getStatusIcon } from './status-icon';
import { ReplaySubject, combineLatest } from 'rxjs';
import { startWith, takeWhile, tap } from 'rxjs/operators';
import { LoggingService } from '../services/logging';

@Component({
    selector: 'ef-status-icon',
    templateUrl: './status-icon.component.html',
    styleUrls: ['./status-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatusIconComponent implements OnDestroy {
    public StatusSubject = new ReplaySubject<number>(1);
    @Input() public set status(value) {
        this.StatusSubject.next(value);
        // this.result = getStatusIcon(value);
    }
    public MessageSubject = new ReplaySubject<string>(1);
    @Input() public set message(value) {
        this.MessageSubject.next(value);
    }
    public result;
    private active = true;
    constructor(
        protected cdRef: ChangeDetectorRef,
        private log: LoggingService
    ) {
        combineLatest([
            this.StatusSubject,
            this.MessageSubject.pipe(startWith(''))
        ])
            .pipe(
                takeWhile(() => this.active)
                // tap(([status, message]) =>
                //     this.log.verbose({
                //         type: 'StatusIconComponent::combineLatest',
                //         status,
                //         message
                //     })
                // )
            )
            .subscribe(([status, message]) => {
                this.result = getStatusIcon(status, message);
                this.cdRef.detectChanges();
            });
    }
    ngOnDestroy() {
        this.active = false;
    }
}
